import React, { useEffect, useState } from 'react';
import { createInstance, OptimizelyProvider } from '@optimizely/react-sdk';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { PricesProvider } from '@fff-web/fff-payments';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import FontAwesome from '@fff-web/fff-ui-shared/FontAwesome';
import { useUserContext } from '@fff-web/fff-utilities';
import { FeatureFlagsContextProvider } from '@fff-web/feature-flags';
import { getUUID } from './utils/Optimizely/experiments';
import { getSubscriptionPlans } from './services/localization';
import AppRoutes from './AppRoutes';
import { SubscriptionPlansContext } from './context/SubscriptionPlansContext';
import { appEnv } from './utils/env';

import './App.css';

const optimizelyClientInstance = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY,
  logLevel: 'error',
});

function App() {
  const [subscriptionPlans, setSubscriptionPlans] = useState(undefined);
  const { userInfo } = useUserContext();
  const userId = userInfo?.user?.userId ?? getUUID();

  useEffect(() => {
    getSubscriptionPlans().then((response) => {
      setSubscriptionPlans(response);
    });
  }, []);

  useEffect(() => {
    if (userId) {
      datadogRum.setGlobalContextProperty('userId', userId);
      datadogLogs.setGlobalContextProperty('userId', userId);
    }
  }, [userId]);

  return (
    <UniversalNavigationContextProvider>
      <OptimizelyProvider optimizely={optimizelyClientInstance} user={{ id: String(userId) }}>
        <PricesProvider>
          <FontAwesome />
          <SubscriptionPlansContext.Provider value={{ subscriptionPlans }}>
            <FeatureFlagsContextProvider appEnv={appEnv}>
              <AppRoutes />
            </FeatureFlagsContextProvider>
          </SubscriptionPlansContext.Provider>
        </PricesProvider>
      </OptimizelyProvider>
    </UniversalNavigationContextProvider>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
  options: { bootstrap: 'localStorage' },
  user: {
    kind: 'user',
    key: 'anonymous',
  },
})(App);
